import { AerometrexMd, CameraMd, FloorplanMd } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { MediaCountIconsMd } from '../types';

export const MediaCountsIconV2: FunctionComponent<{
  iconName: MediaCountIconsMd;
  title: string;
}> = ({ iconName, title }) => {
  const MappedIcon = {
    FloorplanMd,
    CameraMd,
    AerometrexMd,
  }[iconName];
  return <MappedIcon title={title} id={`${title}-icon`} />;
};
